import find from './../assests/finduser.png';
import rayban from './../assests/rayban.png';
import notes from './../assests/Notes.png';
import payment from './../assests/payment.jpg';
import salawat from './../assests/salawat.png';
import speed from './../assests/speed.png';
import dashboard from './../assests/dashboard.png';
import coachbit from './../assests/coachbit.png';
import notability from './../assests/notability.png';
import store from './../assests/store.png';
import company from './../assests/company.png';




export const PortData = [
    {
        id: 1,
        pImg: find,
        pText: 'Find User Tool',
        pLink2: 'https://om2rms.github.io/NameIt/',
        pLive: 'Live Demo'
    },
    {
        id: 2,
        pImg: rayban,
        pText: 'RayBan Site',
        pLink2: 'https://om2rms.github.io/rayBan/',
        pLive: 'Live Demo'


    },
    {
        id: 3,
        pImg: notes,
        pText: 'Notes ',
        pLink2: 'https://small-notes-black.vercel.app/',
        pLive: 'Live Demo'


    },
    {
        id: 4,
        pImg: payment,
        pText: 'Payment Style ',
        pLink2: 'https://om2rms.github.io/Payment_Plan/',
        pLive: 'Live Demo'


    },
    {
        id: 5,
        pImg: salawat,
        pText: 'Salawat',
        pLink2: 'https://salawat.netlify.app/',
        pLive: 'Live Demo'


    },
    {
        id: 6,
        pImg: speed,
        pText: 'Can you Write Speed',
        pLink2: 'https://om2rms.github.io/NeedForSpeed/',
        pLive: 'Live Demo'


    },
    {
        id: 7,
        pImg: coachbit,
        pText: 'Challenge in Twitter to make this design',
        pLink2: 'https://coachbit.netlify.app/',
        pLive: 'Live Demo'


    },
    {
        id: 7,
        pImg: dashboard,
        pText: 'Ecommerce Dashboard',
        pLink2: 'https://shopdashboard000.netlify.app/ecommerce',
        pLive: 'Live Demo'


    },
    {
        id: 8,
        pImg: store,
        pText: 'Store',
        pLink2: 'https://apple-store-olive.vercel.app/',
        pLive: 'Live Demo'

    },
    {
        id: 9,
        pImg: notability,
        pText: 'Classic style notes ',
        pLink2: 'https://om2rms.github.io/Notability/',
        pLive: 'Live Demo'

    },
    {
        id: 10,
        pImg: company,
        pText: 'Company website',
        pLink2: 'https://alwadyalazrq.netlify.app/',
        pLive: 'Live Demo'

    }

];